<template>
    <section :data-slice-type="slice.slice_type" :data-slice-variation="slice.variation" class="slice slice-speakers">
        <div class="slice-title speakers__content">
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="speakers__title" />

            <div v-if="slice.primary.speakers.length" class="slice-body">
                <div class="slice-speakers__speakers">
                    <SpeakerProfileCard v-for="(speakers, i) in slice.primary.speakers" :key="`speaker-item-${i}`" :speaker="speakers" />
                </div>
            </div>

            <div v-else class="speakers__single-speaker-card">
                <MktCardHand event-theme>
                    <PrismicImage :field="slice.primary.image" />
                </MktCardHand>
                <div>
                    <div :class="{'speaker-card__name': true, 'speaker-card__name--single': !slice.primary.speakers.length}">
                        {{ speakerNameAndJobTitle }}
                    </div>
                    <div class="speaker-card__job">{{ description }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {RichTextField} from '@prismicio/types';
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import type {SpeakersSlice} from '@prismicio-types';
    import {MktCardHand} from '#components';
    import {usePrismicTypeGuards} from '#imports';
    import SpeakerProfileCard from './SpeakerProfileCard.vue';

    const props = defineProps(getSliceComponentProps<SpeakersSlice>(['slice', 'index', 'slices', 'context']));

    const {hasProperty} = usePrismicTypeGuards();

    function extractText(nodes: RichTextField) {
        return nodes?.map((node) => (hasProperty(node, 'text') ? node.text : '')).join('') ?? '';
    }

    const name = computed(() => extractText(props.slice.primary.name));
    const description = computed(() => extractText(props.slice.primary.description));
    const speakerNameAndJobTitle = computed(() => `${name.value} - ${props.slice.primary.jobTitle}`);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '~/assets/styles/variables' as *;

    .slice-speakers {
        &__content {
            padding: var(--joy-core-spacing-9) 0;
        }

        &__title {
            text-align: center;
        }

        &__single-speaker-card {
            flex-direction: column;
            text-align: center;

            @include mq.screen_sm() {
                padding: 0 var(--joy-core-spacing-6);
            }

            @include mq.screen_lg(min) {
                width: 100%;
                display: flex;
                text-align: left;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }
        }

        &__speakers {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: var(--joy-core-spacing-10);
        }
    }

    .speaker-card {
        width: 200px;
        flex: none;
        &__name {
            &--single {
                margin-top: 0;
                font-weight: var(--joy-font-weight-normal);
            }
        }
    }

    // .swiper-container {
    //     width: 450px;

    //     @media (min-width: 1316px) {
    //         overflow: visible;
    //         pointer-events: none;
    //         height: auto;
    //         width: inherit;

    //         .swiper-wrapper {
    //             display: flex;
    //             justify-content: center;
    //             gap: 20px;
    //         }
    //     }

    //     @include mq.screen_sm() {
    //         width: 100%;
    //     }

    //     @include swiper-pagination-bullets;

    //     .swiper-pagination {
    //         margin-top: var(--joy-core-spacing-8);
    //     }
    // }

    .resource-page--strategy {
        .card-hand-inner {
            &:after {
                background-color: var(--joy-color-secondary-30);
            }
            &:before {
                background-color: var(--joy-color-tertiary-70);
            }
        }
    }
</style>
